// src/components/Header.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = ({ 
  toggleSidebar, 
  sidebarOpen, 
  onLogout, 
  currentUser 
}) => {
  const location = useLocation();
  
  // Get username from props or sessionStorage
  const userName = currentUser?.employeeName || sessionStorage.getItem('UserName') || '';

  const handleLogout = () => {
    if (onLogout) {
      sessionStorage.removeItem('UserName');
      onLogout();
    }
  };

  return (
    <header className={`header ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <div className="header-left">
        <button 
          className={`hamburger-btn ${sidebarOpen ? 'active' : ''}`} 
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      
      <div className="header-center">
        <nav className="header-nav">
          <Link 
            to="/home" 
            className={`nav-link ${location.pathname === '/' || location.pathname === '/home' ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link 
            to="/summary" 
            className={`nav-link ${location.pathname === '/summary' ? 'active' : ''}`}
          >
            Summary
          </Link>
          <Link 
            to="/settings" 
            className={`nav-link ${location.pathname.startsWith('/settings') ? 'active' : ''}`}
          >
            Settings
          </Link>
        </nav>
      </div>

      <div className="header-right">
        <div className="user-info">
          <span className="welcome-text">Welcome, {userName}</span>
          <button 
            className="logout-btn" 
            onClick={handleLogout}
            aria-label="Logout"
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16,17 21,12 16,7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;